module.exports = __webpack_public_path__ + "images/_/javascripts/components/modal/guidance_slider_modal/images/second2_b4b1769590fb8b90ee06c13282a694d6.png";